<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
     <div class="d-flex justify-content-between">
      <div class="section-title mb-4">{{ $t("advancebookingreport") }}</div>
      <div 
      v-if="
              getAdvanceBookingReportData &&
              getAdvanceBookingReportData.length > 0
            "
      class="">
            <b-dropdown
              name="listview"
              id="listview"
              variant="outline-blue"
              class=""
            >
              <template v-slot:button-content>
                {{ $tc("viewing") }}&nbsp;
                <strong>{{ updateSelectedValue }}</strong>
                &nbsp;Of&nbsp;
                <strong>{{ getAdvanceBookingReportTotalRows }}</strong>
              </template>
              <b-dropdown-item
                v-for="(list, listIndex) in viewingnumbers"
                :key="listIndex"
                @click="onDropDownChangeValue(list.name)"
                >{{ list.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
          <div v-else></div>
     </div>
      <div class="mt-3 mb-0">
        <div class="row">
          <!-- SELECT DROPDOWN -->

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <!-- <label
                :class="getAdvanceBookingReportSelectedCinema ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :text="getAdvanceBookingReportSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    :placeholder="$tc('searchCinema')"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  @click="
                    onAdvanceBookingReportDropDownHandler({
                      event: $event,
                      name: 'isCinema',
                      selectedItem: dropdownItem,
                      index: dropdownIndex,
                    });
                    searchCinema = '';
                    onSearchCinema();
                    onSelectCinema(dropdownItem);
                  "
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown> -->
              <label
                :class="
                  selectedCinema && selectedCinema.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :options="Cinemas"
                v-model="selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :showLabels="false"
                :multiple="true"
               ></multiselect>
            </div>
          </div>
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getAdvanceBookingReportFromDate"
                  @click="
                    onDateChange({
                      event: null,
                      name: 'fromDate',
                    })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onDateChange({
                      event: $event,
                      name: 'fromDate',
                    })
                  "
                  :value="getAdvanceBookingReportFromDate || defaultFromDate"
                  typeable
                ></Datepicker>
                <label
                  :class="
                    getAdvanceBookingReportFromDate || defaultFromDate
                      ? 'active'
                      : ''
                  "
                  >{{ $t("startdate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-4">
            <button
              @click="onFetchAdvanceBookingReport({cinema_ids:cinemaIds})"
              class="btn-blue"
            >
              {{ $tc("fetch") }}
            </button>
          </div>

          <div
          v-if="
              getAdvanceBookingReportData &&
              getAdvanceBookingReportData.length > 0
            "
            class="align-self-center mb-4 d-flex justify-content-end align-items-center"
          >
            <div>{{ $t("download") }} as:</div>
            <a
              v-if="getAdvanceBookingReportsPDFFileName"
              :href="BASE_URL + getAdvanceBookingReportsPDFFileName"
              target="_blank"
              download
              title="Download as PDF"
            >
              <img
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a>

            <a
              v-if="getAdvanceBookingReportsExcelFileName"
              :href="BASE_URL + getAdvanceBookingReportsExcelFileName"
              target="_blank"
              title="Download as Excel"
              download
              class="mx-2"
            >
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </a>
            <!-- <img
              src="@/assets/img/icons/excel.svg"
              height="25"
              width="25"
              class="mx-2"
            /> -->
          </div>
     
        </div>
      </div>

      <!-- //Excel Data -->
      <table
        class="d-none"
        border="1"
        ref="exportable_table"
        style="width: auto !important; white-space: nowrap"
      >
        <thead class>
          <tr class="bg-lightgrey">
            <!-- <th>{{ $t("voucher") }} {{ $t("no") }}</th>
            <th>{{ $tc("booking", 1) }} {{ $tc("date", 1) }}</th> -->
            <th>{{ $tc("cinema") }} {{ $t("name") }}</th>
            <th>{{ $tc("film", 1) }} {{ $t("name") }}</th>
            <th>{{ $tc("sale") }} {{ $t("channel") }}</th>
            <th>{{ $t("show") }} {{ $tc("date", 1) }}</th>
            <th>{{ $t("show") }} {{ $tc("time", 1) }}</th>
            <th>{{ $tc("screen", 1) }} {{ $tc("name", 1) }}</th>
            <th>{{ $tc("seat", 1) }} {{ $tc("number", 1) }}</th>
            <th>{{ $t("net") }} {{ $tc("rate") }}</th>
            <th>{{ $t("net") }} {{ $tc("sale") }} {{ $tc("price") }}</th>
            <th>{{ $t("discount") }}</th>
            <th>P.{{ $t("type") }}</th>
            <!-- <th>{{ $t("mobileNo") }}</th> -->
            <th colspan="2">{{ $t("transaction") }} {{ $t("number") }}</th>
            <th colspan="2">{{ $t("Order") }} {{ $t("Code") }}</th>
            <th colspan="2">{{ $t("Items") }} </th>
            <th colspan="1">{{ "Fnb Discount" }}</th>
            <th colspan="1"> {{"Fnb Total Amount" }}</th>
            <th colspan="1">{{ $t("Customer") }} {{ $t("Name") }}</th>
            <th colspan="1"> {{ $t("Email") }}</th>
            <th colspan="1"> {{ $t("Mobile") }}</th>
            <th colspan="1"> {{ "Is Guest User" }}</th>
            <th colspan="1"> {{ $t("Card Number") }}</th>
            <th colspan="1"> {{ $t("reference") }} {{ $t("number") }}</th>
            <th colspan="3">{{ $t("BO") }} {{ $t("Remarks") }}</th>
            <th colspan="3">{{ $t("Fnb") }} {{ $t("Remarks") }}</th>

          </tr>
        </thead>
        <tbody v-if="getAdvanceBookingReportData.length > 0" class="sph-report">
          <tr
            v-for="(
              transaction, transactionIndex
            ) in getAdvanceBookingReportData"
            :key="transactionIndex"
          >
            <!-- <td>{{ transaction.offer_name || "-" }}</td>
            <td>{{ transaction.t_booking_date_time | dateparse }}</td> -->
            <td class="text-left">{{ transaction.cinema_name }}</td>
            <td class="text-left">{{ transaction.film_name }}</td>
            <td class="text-left">{{ transaction.bs_source }}</td>

            <td>{{ transaction.t_show_date | dateparse }}</td>
            <td class="text-right">{{ transaction.t_show_time }}</td>
            <td class="text-left">{{ transaction.screen_name }}</td>
            <td class="text-right seat_break text-wrap">
              {{ transaction.seats.split(",").join(", ") }}
            </td>
            <td class="text-right">
              {{ currFormat(transaction.t_net_amount) }}
            </td>
            <td class="text-right">
              {{ currFormat(transaction.sb_total_amount) }}
            </td>
            <td class="text-right">{{ currFormat(transaction.discount) }}</td>
            <td>{{ transaction.p_type || "-" }}</td>
            <!-- <td class="text-center">
              {{ transaction.customer_mobile || "-" }}
            </td> -->
            <td colspan="2" class="text-right">
              {{ transaction.sb_booking_code }}
            </td>
            <td colspan="2" class="text-right">
              {{ transaction.order_code || "-" }}
            </td>
            <td colspan="2" class="text-right">
              {{ transaction.item_names || "-" }}
            </td>
            <td colspan="1" class="text-right">
              {{ transaction.ft_offer_price || "-" }}
            </td>
            <td colspan="1" class="text-right">
              {{ transaction.ft_total_amount || "-" }}
            </td>
            <td colspan="1" class="text-left">
              {{ transaction.customer_name || transaction.guest_customer_name  || "-" }}
            </td>
            <td colspan="1" class="text-right">
              {{ transaction.cust_email || transaction.guest_email  ||"-" }}
            </td>
            <td colspan="1" class="text-right">
              {{ transaction.customer_mobile || transaction.guest_mobile  ||"-" }}
            </td>
            <td colspan="1" class="text-left">
              {{ transaction.is_guest_user  ||"-" }}
            </td>
            <td colspan="1" class="text-right">
              {{ transaction.card_no || "-" }}
            </td>
            <td colspan="1" class="text-right">
              {{ transaction.bank_ref_no || "-" }}
            </td>
            <td class="text-left" colspan="3">
              {{ transaction.bo_trx_remarks || "-" }}
            </td>
            
            <td class="text-left" colspan="3">
              {{ transaction.ft_trx_remarks || "-" }}
            </td>
          </tr>
        </tbody>
        <tbody v-else class="sph-report">
          <td colspan="15">
            <!-- {{ $tc("NoRecords") }} -->
            <NoRecords />
          </td>
        </tbody>
      </table>
      <!-- //Excel Data -->

      <div class="swc-report mt-2" style="overflow-x: scroll">
        <table class="swc-report-table" border="1">
          <thead class>
            <tr class="bg-lightgrey">
              <!-- <th>{{ $t("voucher") }} {{ $t("no") }}</th>
              <th>{{ $tc("booking", 1) }} {{ $tc("date", 1) }}</th> -->
              <th>{{ $tc("cinema") }} {{ $t("name") }}</th>
              <th>{{ $tc("film", 1) }} {{ $t("name") }}</th>
              <th>{{ $tc("sale") }} {{ $t("channel") }}</th>
              <th>{{ $t("show") }} {{ $tc("date", 1) }}</th>
              <th>{{ $t("show") }} {{ $tc("time", 1) }}</th>
              <th>{{ $tc("screen", 1) }} {{ $tc("name", 1) }}</th>
              <th>{{ $tc("seat", 1) }} {{ $tc("number", 1) }}</th>
              <th>{{ $t("Ticket") }} {{ $tc("Rate") }}</th>
              <th>{{ $t("Transaction ") }} {{ $tc("Amount") }}</th>
              <th>{{ $t("discount") }}</th>
              <th>P.{{ $t("type") }}</th>
              <!-- <th>{{ $t("mobileNo") }}</th> -->
              <th colspan="2">{{ $t("transaction") }} {{ $t("number") }}</th>
              <th colspan="1">{{ $t("Order") }} {{ $t("Code") }}</th>
              <th colspan="2">{{ $t("Items") }} </th>
              <th colspan="1">  {{ "Fnb Discount" }}</th>
              <th colspan="1"> {{ "Fnb Total Amount" }}</th>
              <th colspan="1">{{ $t("Customer") }} {{ $t("Name") }}</th>
              <th colspan="1"> {{ $t("Email") }}</th>
              <th colspan="1"> {{ $t("Mobile") }}</th>
              <th colspan="1"> {{ "Is Guest User"  }}</th>
              <th colspan="1"> {{ $t("Card Number") }}</th>
              <th colspan="1"> {{ $t("reference") }} {{ $t("number") }}</th>
              <th colspan="3">{{ $t("BO") }} {{ $t("Remarks") }}</th>
              <th colspan="3">{{ $t("Fnb") }} {{ $t("Remarks") }}</th>

              <th class="d-none">{{ $t("HHId") }}</th>
            </tr>
          </thead>
          <tbody
            v-if="getAdvanceBookingReportData.length > 0"
            class="sph-report"
          >
            <tr
              v-for="(
                transaction, transactionIndex
              ) in getAdvanceBookingReportData"
              :key="transactionIndex"
            >
              <!-- <td>{{ transaction.offer_name || "-" }}</td>
              <td>{{ transaction.t_booking_date_time | dateparse }}</td> -->
              <td class="text-left">{{ transaction.cinema_name }}</td>
              <td class="text-left">{{ transaction.film_name }}</td>
              <td class="text-left">{{ transaction.bs_source }}</td>
              <td>{{ transaction.t_show_date | dateparse }}</td>
              <td class="text-right">{{ transaction.t_show_time }}</td>
              <td class="text-left">{{ transaction.screen_name }}</td>
              <td class="text-right seat_break text-wrap">
                {{ transaction.seats.split(",").join(", ") }}
              </td>
              <td class="text-right">
                {{ currFormat(transaction.t_net_amount) }}
              </td>
              <td class="text-right">
                {{ currFormat(transaction.sb_total_amount) }}
              </td>
              <td class="text-right">{{ currFormat(transaction.discount) }}</td>
              <td>{{ transaction.p_type || "-" }}</td>
              <!-- <td class="text-right">
                {{ transaction.sb_mobile_number || "-" }}
              </td> -->
              <td colspan="2" class="text-right">
                {{ transaction.sb_booking_code }}
              </td>
              <td colspan="1" class="text-right">
              {{ transaction.order_code || "-" }}
            </td>
            <td colspan="2" class="text-left">
              {{ transaction.item_names || "-" }}
            </td>
            <td colspan="1" class="text-right">
              {{ currFormat(transaction.ft_offer_price) || "-" }}
            </td>
            <td colspan="1" class="text-right">
              {{ currFormat(transaction.ft_total_amount) || "-" }}
            </td>
            <td colspan="1" class="text-left">
              {{ transaction.customer_name || transaction.guest_customer_name  || "-" }}
            </td>
            <td colspan="1" class="text-right">
              {{ transaction.cust_email || transaction.guest_email  ||"-" }}
            </td>
           
            <td colspan="1" class="text-right">
              {{ transaction.customer_mobile || transaction.guest_mobile  ||"-" }}
            </td>
            <td colspan="1" class="text-right">
              {{ transaction.is_guest_user ||"-" }}
            </td>
            <td colspan="1" class="text-right">
              {{ transaction.card_no || "-" }}
            </td>
            <td colspan="1" class="text-right">
              {{ transaction.bank_ref_no || "-" }}
            </td>
              <td  colspan="3"class="text-left">{{ transaction.bo_trx_remarks || "-" }}</td>
              <td colspan="3" class="text-left">{{ transaction.ft_trx_remarks || "-" }}</td>
              <td class="d-none">{{ transaction.HHHId || "-" }}</td>

            </tr>
          </tbody>
          <tbody v-else class="sph-report">
            <td colspan="16" class="text-center">
              {{ $tc("NoRecords") }}
              <!-- <NoRecords /> -->
            </td>
          </tbody>
        </table>
      </div>
      <b-pagination
        v-if="getAdvanceBookingReportData.length > 0"
        v-model="getAdvanceBookingReportcurrentPage"
        :total-rows="getAdvanceBookingReportTotalRows"
        @change="onChangePagination($event)"
        :per-page="updatePerPage"
        aria-controls="my-table"
        class="my-3"
      ></b-pagination>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import * as XLSX from "xlsx";
import { mapState, mapGetters, mapActions } from "vuex";
import MasterService from "@/services/MasterService";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: { DatePicker, NoRecords },
  data() {
    return {
      CinemasCopy: [],
      searchCinema: "",
      Cinemas: [],
      selectedCinema:[],
      cinemaIds:"",
      isRoleID: true,
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [],
    };
  },
  computed: {
    ...mapGetters([
      "getCinemasList",
      "getAdvanceBookingReportSelectedCinema",
      "getAdvanceBookingReportFromDate",
      "getAdvanceBookingReportData",
      "getAdvanceBookingReportLimit",
      "getAdvanceBookingReportcurrentPage",
      "getAdvanceBookingReportTotalRows",
      "getAdvanceBookingReportperPage",
      "getAdvanceBookingReportselectedValue",
      // EXCEL
      "getAdvanceBookingReportsExcelFileName",
      // PDF
      "getAdvanceBookingReportsPDFFileName",
    ]),
    defaultFromDate() {
      return new Date();
    },
    updateLimit() {
      return this.$store.getters.getAdvanceBookingReportLimit;
    },
    updatePerPage: {
      get() {
        return this.$store.getters.getAdvanceBookingReportperPage;
      },
      set(value) {
        return this.$store.dispatch("updatePerPage", value);
      },
    },
    updateSelectedValue: {
      get() {
        return this.$store.getters.getAdvanceBookingReportselectedValue;
      },
      set(value) {
        return this.$store.dispatch("updateSelectedValue", value);
      },
    },
  },

  mounted() {
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getviewingnumber();
    // if (CinemaObj) {
    //   this.onAdvanceBookingReportDropDownHandler({
    //     event: null,
    //     name: "isCinema",
    //     selectedItem: CinemaObj
    //   });
    // }

    // this.fetchCinemasList({ cinemaId });
  },

  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onAdvanceBookingReportDropDownHandler({
    //       event: null,
    //       name: "isCinema",
    //       selectedItem: CinemaObj
    //     });
    //   }
    // }
  },
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDateChange:function(payload){
      console.log("payload",payload)
      this.onAdvanceBookingReportDropDownHandler(payload)
      this.onAdvanceBookingReportDropDownHandler({
          name: "currentPage",
          currentPage: 1,
        });
    },
    onDropDownChangeValue(event) {
      console.log("event",event)
      if (event == "All") {
        this.onAdvanceBookingReportDropDownHandler({
          name: "limit",
          limit: this.getAdvanceBookingReportTotalRows,
        });
        // this.perPage = this.getAdvanceBookingReportLimit;
        this.updatePerPage = this.getAdvanceBookingReportLimit;
        this.updateSelectedValue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.updateSelectedValue = event;
        this.updatePerPage = event;
        // this.perPage = event;
        this.onAdvanceBookingReportDropDownHandler({
          name: "limit",
          limit: event,
        });
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    onChangePagination: function (event) {
      console.log(event);
      if (event === undefined) {
        this.onAdvanceBookingReportDropDownHandler({
          name: "currentPage",
          currentPage: 1,
        });
        // this.currentPage = 1;
        this.onFetchAdvanceBookingReport({cinema_ids:this.cinemaIds});
      } else {
        this.onAdvanceBookingReportDropDownHandler({
          name: "currentPage",
          currentPage: event,
        });
        // this.currentPage = event;
        this.onFetchAdvanceBookingReport({cinema_ids:this.cinemaIds});
      }
    },
    ExportExcel(type, fn, dl) {
      let cinemaName = this.getAdvanceBookingReportSelectedCinema || "";
      let fromDate = this.getAdvanceBookingReportFromDate;
      var today = new Date();
      var date =
        String(today.getDate()).padStart(2, "0") +
        "-" +
        String(today.getMonth() + 1).padStart(2, "0") +
        "-" +
        today.getFullYear();
      var time =
        String(today.getHours()).padStart(2, "0") +
        ":" +
        String(today.getMinutes()).padStart(2, "0") +
        ":" +
        String(today.getSeconds()).padStart(2, "0");

      var dateTime = date + "_AT_" + time;
      let fileName =
        "AdvanceBookingReport-" +
        cinemaName +
        "_" +
        fromDate +
        "_" +
        "_on " +
        dateTime +
        (type ? "." + type : ".xlsx");
      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, {
        sheet: "Advance Booking Report",
      });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : // XLSX.insert_image('B12', 'python.png', {'x_offset': 15, 'y_offset': 10})
          XLSX.writeFile(wb, fn || fileName);
    },
    onSelectCinema(cinema) {
      if(cinema.length){
        this.cinemaIds=cinema.map(ele=>ele.cine_id).join(",")
      }
      this.$store.dispatch("selectDropdownCinema", cinema);
      this.onAdvanceBookingReportDropDownHandler({
          name: "currentPage",
          currentPage: 1,
        });
    },
    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getCinemaList: function (cine_id) {
      this.Cinemas = [];
      //  let payload = null
      //   cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
      MasterService.GetCinemasByRoles({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            // this.CinemasCopy = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                // let cinema = {
                //   cine_name: x.cine_name,
                //   cine_id: x.cine_id
                // };

                // this.onSelectCinema(null,cinema);
                this.onAdvanceBookingReportDropDownHandler({
                  name: "isCinema",
                  selectedItem: {
                    cine_name: x.cine_name,
                    cine_id: x.cine_id,
                  },
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    ...mapActions([
      //
      "fetchCinemasList",
      "onAdvanceBookingReportDropDownHandler",
      "onFetchAdvanceBookingReport",
    ]),
  },
};
</script>

<style scoped>
.swc-report {
  border-collapse: collapse;
  width: 100%;
}

.swc-report , 
.swc-report td {
  border: 1px solid rgb(161, 160, 160); /* Light grey border for all cells */
  padding: 8px; /* Optional: Adjust padding for better spacing */
  text-align: left; /* Optional: Ensure left alignment */
}

.swc-report-table {
  border: 1px solid black; /* Border for the entire table */
}


</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/advanceBookingReport.vue